/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';
import { setModuleAccess, setSession } from 'src/utils/jwt';
import useAuth from 'src/hooks/useAuth';

const initialState = {
  isLoading: false,
  error: '',
  usersMsg: '',
  status: true,
  createUsersStatus: false,
  usersList: [],
  disableUsersList: [],
  accessModules: []
};

const slice = createSlice({
  name: 'users__',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET ERROR
    resetUsersError(state) {
      state.error = '';
    },
    // RESET MSG
    resetUsersMsg(state) {
      state.usersMsg = '';
    },
    // RESET CREATE STATUS
    resetCreateUsersStatus(state) {
      state.createUsersStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createUsersStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    usersStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET USERS LIST
    getUsersListSuccess(state, action) {
      state.isLoading = false;
      state.usersList = action.payload;
    },
    // GET DISABLE USERS LIST
    getDisableUsersSuccess(state, action) {
      state.disableUsersList = action.payload;
      state.isLoading = false;
    },
    // CREATE USERS
    createUsersSuccess(state, action) {
      const newUsers = action.payload;
      state.createUsersStatus = true;
      state.isLoading = false;
      state.usersList = [...state.usersList, newUsers];
    },
    // UPDATE USERS
    updateUsersSuccess(state, action) {
      const users = action.payload;
      state.createUsersStatus = true;
      const updateUsers = map(state.usersList, (_users) => {
        if (_users.id === users.id) {
          return users;
        }
        return _users;
      });
      state.isLoading = false;
      state.usersList = updateUsers;
    },
    getModuleRolesSuccess(state, action) {
      state.isLoading = false;
      state.accessModules = action.payload;
    },
    // FILTER USERS
    filterUsersSuccess(state, action) {
      const users = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.usersList = users;
      } else {
        state.disableUsersList = users;
      }
    },
    // DISABLE OR RESTORE USERS
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.usersMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const usersStatus = filter(state.status ? state.disableUsersList : state.usersList, (users) => users.id !== id);
        state.isLoading = false;
        if (state.status) {
          state.createUsersStatus = false;
          state.usersMsg = '';
          state.disableUsersList = usersStatus;
        } else {
          state.createUsersStatus = true;
          state.usersList = usersStatus;
        }
      }
    },
    // DELETE CLIENT
    deleteUsersSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableUsersList, (users) => users.id !== id);
      state.isLoading = false;
      state.disableUsersList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateUsersStatus, resetUsersError, resetUsersMsg } = slice.actions;

// ----------------------------------------------------------------------

// GET USERS LIST GET
export function getUsersList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getUsersListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableUsersSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE USERS POST
export function createUsers(userData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/cp360adminlogin/user-create/',
        data: userData
      });
      dispatch(slice.actions.createUsersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE USERS PUT
export function updateUsers(userData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-details-edit/${id}/`,
        data: userData
      });
      dispatch(slice.actions.updateUsersSuccess(response.data));
      setSession(accessToken, response.data);
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER USERS GET
export function filterUsers(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.usersStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user/filter/item/?first_name${name}&status=${pageStatus}`
      });
      dispatch(slice.actions.filterUsersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING OR RESTORING OF PARTICULAR USERS PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.usersStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE USERS DELETE
export function deleteUsers(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-delete/${id}/`
      });
      dispatch(slice.actions.deleteUsersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function getModuleRoles() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');

      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/user-role-list/`
      });

      setModuleAccess(response.data.module_wise_permissions);
      dispatch(slice.actions.getModuleRolesSuccess(response.data.module_wise_permissions));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
